import React from 'react';
import { CalculatorInputs as InputsType, TimePeriod } from '../../types/calculator';
import { SLIDER_CONFIGS } from '../../constants/defaults';
import { SliderInput } from './SliderInput';
import { Card } from '../ui/Card';
import { Settings } from 'lucide-react';
import { TimePeriodToggle } from './TimePeriodToggle';

interface CalculatorInputsProps {
  inputs: InputsType;
  onInputChange: <K extends keyof InputsType>(key: K, value: InputsType[K]) => void;
  timePeriod: TimePeriod;
  onTimePeriodChange: (period: TimePeriod) => void;
}

export const CalculatorInputs: React.FC<CalculatorInputsProps> = ({
  inputs,
  onInputChange,
  timePeriod,
  onTimePeriodChange,
}) => {
  return (
    <Card className="h-fit">
      {/* Header with dropdown on desktop */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <div className="flex items-center gap-2">
          <Settings className="w-5 h-5 text-orange" />
          <h2 className="text-xl font-serif font-semibold text-offblack">
            Your Workplace
          </h2>
        </div>
        <div className="w-full sm:w-48">
          <TimePeriodToggle
            selected={timePeriod}
            onChange={onTimePeriodChange}
          />
        </div>
      </div>

      <SliderInput
        config={SLIDER_CONFIGS.employeeCount}
        value={inputs.employeeCount}
        onChange={(value) => onInputChange('employeeCount', value)}
      />

      <SliderInput
        config={SLIDER_CONFIGS.avgSalary}
        value={inputs.avgSalary}
        onChange={(value) => onInputChange('avgSalary', value)}
      />

      <SliderInput
        config={SLIDER_CONFIGS.breakDuration}
        value={inputs.breakDuration}
        onChange={(value) => onInputChange('breakDuration', value)}
      />

      <SliderInput
        config={SLIDER_CONFIGS.cupsPerEmployee}
        value={inputs.cupsPerEmployee}
        onChange={(value) => onInputChange('cupsPerEmployee', value)}
      />

      <SliderInput
        config={SLIDER_CONFIGS.officeDaysPerWeek}
        value={inputs.officeDaysPerWeek}
        onChange={(value) => onInputChange('officeDaysPerWeek', value)}
      />

      <SliderInput
        config={SLIDER_CONFIGS.subsidyPercent}
        value={inputs.subsidyPercent}
        onChange={(value) => onInputChange('subsidyPercent', value)}
      />
    </Card>
  );
};
